module.exports = __webpack_public_path__ + "assets/images/heatmap-78fe18a2319fdfb59bd71089f74ef47e.gif";